import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutEmptyComponent } from './layouts/layout-empty/layout-empty.component';
import { LoginComponent } from './views/login/login.component';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { SettingsComponent } from "./views/settings/settings.component";
import { RegisterComponent } from "./views/register/register.component";
import { ErrorComponent } from './views/error/error.component';
import { LayoutSidenavigationComponent } from './layouts/layout-sidenavigation/layout-sidenavigation.component';
import { AlarmSettingsComponent } from './views/alarm-settings/alarm-settings.component';
import { AccessManagementComponent } from './views/access-management/access-management.component';
import { PasswordResetComponent } from './views/password-reset/password-reset.component';
import { DocumentationComponent } from './views/documentation/documentation.component';
import { ForceChangePasswordComponent } from './views/force-change-password/force-change-password.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutEmptyComponent,
    children: [
      {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full'
      },
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'auto-login',
        component: LoginComponent
      },
      {
        path: 'register/:secret',
        component: RegisterComponent
      },
      {
        path: 'password-reset',
        component: PasswordResetComponent
      },
      {
        path: 'docs/:file',
        component: DocumentationComponent
      },
      {
        path: 'change-password',
        component: ForceChangePasswordComponent
      }
    ]
  },
  {
    path: 'frame',
    component: LayoutSidenavigationComponent,
    children: [
      // Do not delete the following line!
      // @insert_generated_views
      {
        path: 'dashboards',
        component: DashboardComponent
      },
      {
        path: 'alarm-settings',
        component: AlarmSettingsComponent
      },
      {
        path: 'access-management',
        component: AccessManagementComponent
      },
      {
        path: 'settings',
        component: SettingsComponent
      },
      {
        path: 'error',
        component: ErrorComponent
      },
      {
        path: 'documentation',
        component: DocumentationComponent
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule
  ],
  declarations: []
})
export class AppRoutingModule { }
